import React, { useRef } from "react";
import { string } from "prop-types";
import { SearchBox } from "@quintype/components";

import SearchIcon from "../../atoms/icons/search-icon";

import "./search-input.m.css";

const DrawForm = ({ children }) => [
  <label htmlFor="searchForm" key="1">
    {children}
  </label>,
  <button type="submit" styleName="search" key="2">
    <SearchIcon color="#0099ff" width={28} height={28} />
  </button>
];

const SearchInput = ({ className, defaultValue }) => {
  const textInput = useRef();
  const searchForm = useRef();

  return (
    <div styleName="container" className={className}>
      <SearchBox
        styleName="search-box"
        inputId="searchForm"
        inputClassName="search__form-input"
        template={DrawForm}
        inputRef={textInput}
        formRef={searchForm}
        placeholder="Search"
        initValue={defaultValue}
      />
    </div>
  );
};

SearchInput.defaultProps = {
  className: ""
};

SearchInput.propTypes = {
  defaultValue: string,
  className: string
};

export default SearchInput;
